module.exports = __webpack_public_path__ + "static/animation-map-pin2-32a1121047cdce6e53949152627d2d94.png";